import React from "react";
import "./Load.scss";
function Load({ ...attrs }) {
	return (
		<div className="load" {...attrs}>
			<svg
				width="20"
				height="25"
				viewBox="0 0 20 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9.14443 2.31039C8.57307 2.31039 8.10986 2.7736 8.10986 3.34496V3.84859C8.10986 5.1251 7.28573 6.21202 6.14191 6.60729V3.34496C6.14191 2.7736 5.6787 2.31039 5.10735 2.31039C4.53599 2.31039 4.07278 2.7736 4.07278 3.34496V6.54377C3.01718 6.10394 2.27305 5.06172 2.27305 3.84859V3.34496C2.27305 2.7736 1.80984 2.31039 1.23848 2.31039C0.667128 2.31039 0.203918 2.7736 0.203918 3.34496V3.84859C0.203918 6.21409 1.85971 8.1988 4.07278 8.70815V12.7397H2.95186C2.38051 12.7397 1.9173 13.2029 1.9173 13.7743V21.81C1.9173 23.5689 3.34838 25 5.10735 25C6.86631 25 8.29739 23.5689 8.29739 21.81V13.7743C8.29739 13.2029 7.83418 12.7397 7.26283 12.7397H6.14191V8.74422C8.43885 8.29908 10.179 6.27368 10.179 3.84859V3.34496C10.179 2.77353 9.71578 2.31039 9.14443 2.31039V2.31039ZM6.22833 21.8099C6.22833 22.4279 5.72546 22.9308 5.10741 22.9308C4.48936 22.9308 3.9865 22.4279 3.9865 21.8099V14.8088H6.2284V21.8099H6.22833Z"
					stroke="#FE724C"
				/>
				<path
					d="M13.0205 0.930969C12.4492 0.930969 11.986 1.39418 11.986 1.96553V21.81C11.986 23.569 13.417 25 15.176 25C16.935 25 18.3661 23.569 18.3661 21.81V14.8022C18.8837 14.7453 19.2865 14.307 19.2865 13.7743V7.19699C19.2865 3.74188 16.4756 0.930969 13.0205 0.930969V0.930969ZM14.0551 3.12908C15.8705 3.59104 17.2174 5.23973 17.2174 7.19692V12.7396H14.0551V3.12908ZM15.1761 22.9308C14.558 22.9308 14.0552 22.4279 14.0552 21.8099V14.8088H16.2971V21.81C16.297 22.4279 15.7941 22.9308 15.1761 22.9308V22.9308Z"
					fillOpacity="0.7"
					stroke="#FE724C"
				/>
			</svg>
		</div>
	);
}

export default Load;
